import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { UserAitSearchRequest } from '../shared/models/users/user-ait-search-request';
import { UserAitSearchResponse } from '../shared/models/users/user-ait-search-response';

@Injectable({
  providedIn: 'root',
})
export class UserAitService {
  env = environment;
  apiUrl = this.env.apiurl + 'platform/users/';

  constructor(
    private http: HttpClient,
    public router: Router
  ) {}

  public SearchUserAitInfo(
    searchRequest: UserAitSearchRequest
  ): Observable<UserAitSearchResponse[]> {
    return this.http
      .post<any>(`${this.apiUrl}ait-info`, searchRequest, {
        observe: 'response',
      })
      .pipe(
        map((res) => {
          if (res) {
            if (res.status == 200) {
              return res.body.map((data: UserAitSearchResponse) =>
                new UserAitSearchResponse().deserialize(data)
              );
            }
          }
        })
      );
  }
}
